export enum OperatingSystem {
  MacOS = "MacOS",
  Windows = "Windows",
  iOS = "iOS",
  Android = "Android",
  Linux = "Linux",
  Unknown = "Unknown",
}
